import { message } from 'antd';
import axios from 'axios';
import API_BASE_URL from '../../apiConfig';

function getUserId(){
    const user = JSON.parse(localStorage.getItem('user'))
    return user ? user._id : null
}

export const getAllCars=()=>async dispatch=>{

    dispatch({type: 'LOADING' , payload:true})

    try {
        const response = await axios.get(`${API_BASE_URL}/api/cars/getallcars`)
        dispatch({type: 'GET_ALL_CARS', payload:response.data})
        dispatch({type: 'LOADING' , payload:false})
    } catch (error) {
        console.log(error)
        dispatch({type: 'LOADING' , payload:false})
    }

}

export const getMyCars=()=>async dispatch=>{

    dispatch({type: 'LOADING' , payload:true})

    try {
        const userId = getUserId()
        const response = await axios.get(`${API_BASE_URL}/api/cars/getmycars/${userId}?userId=${userId}`)
        dispatch({type: 'GET_ALL_CARS', payload:response.data})
        dispatch({type: 'LOADING' , payload:false})
    } catch (error) {
        console.log(error)
        dispatch({type: 'LOADING' , payload:false})
    }

}

export const addCar=(reqObj)=>async dispatch=>{

    dispatch({type: 'LOADING' , payload:true})

    try {
         await axios.post(`${API_BASE_URL}/api/cars/addcar`, {...reqObj, userId: getUserId()})
       
         dispatch({type: 'LOADING' , payload:false})
         message.success('New car added successfully')
         setTimeout(() => {
            window.location.href='/admin'
         }, 500);
    } catch (error) {
        console.log(error)
        dispatch({type: 'LOADING' , payload:false})
        message.error(error.response?.data || 'Something went wrong')
    }
      

}

export const editCar=(reqObj)=>async dispatch=>{

    dispatch({type: 'LOADING' , payload:true})

    try {
         await axios.post(`${API_BASE_URL}/api/cars/editcar`, {...reqObj, userId: getUserId()})
       
         dispatch({type: 'LOADING' , payload:false})
         message.success('Car details updated successfully')
         setTimeout(() => {
            window.location.href='/admin'
         }, 500);
    } catch (error) {
        console.log(error)
        dispatch({type: 'LOADING' , payload:false})
        message.error(error.response?.data || 'Something went wrong')
    }
      

}

export const deleteCar=(reqObj)=>async dispatch=>{

    dispatch({type: 'LOADING' , payload:true})

    try {
         await axios.post(`${API_BASE_URL}/api/cars/deletecar`, {...reqObj, userId: getUserId()})
       
         dispatch({type: 'LOADING' , payload:false})
         message.success('Car deleted successfully')
         setTimeout(() => {
            window.location.reload()
         }, 500);
    } catch (error) {
        console.log(error)
        dispatch({type: 'LOADING' , payload:false})
        message.error(error.response?.data || 'Something went wrong')
    }
      

}
